import * as Yup from 'yup';

export const getCompanyInformationSchema = () => {
  return Yup.object().shape({
    name: Yup.string()
      .required('Legal Name is required')
      .test('no-whitespace-only', 'Legal Name cannot be only whitespace', (value) => {
        return value ? /\S/.test(value) : false;
      })
      .trim(),
    displayName: Yup.string()
      .optional()
      .test('no-whitespace-only', 'Business Name cannot be only whitespace', (value) => {
        return !value || /\S/.test(value);
      })
      .trim(),
    kycBusinessTypeId: Yup.string().required('Industry is required'),
    otherBusinessType: Yup.string().optional(),
  });
};

// Keep the old export for backward compatibility, but it won't validate otherBusinessType
export const companyInformationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required('Legal Name is required')
    .test('no-whitespace-only', 'Legal Name cannot be only whitespace', (value) => {
      return value ? value.trim().length > 0 : false;
    }),
  displayName: Yup.string()
    .trim()
    .optional()
    .test('no-whitespace-only', 'Business Name cannot be only whitespace', (value) => {
      return !value || value.trim().length > 0;
    }),
  kycBusinessTypeId: Yup.string().required('Industry is required'),
});

export const companyDocumentSchema = Yup.object().shape({
  documentPath: Yup.string().required('Document is required'),
});
